import { defineStore } from "pinia"
import type {
  SlideOverHeaderProps,
  SlideOverContentProps,
  SlideOver
} from "@/types/slideOver"

export const useSlideOver = defineStore("slideOver", {
  state: () => ({
    items: [] as SlideOver[]
  }),

  getters: {
    isOpen: state => state.items.length > 0
  },

  actions: {
    triggerSlideOver(
      content: SlideOverContentProps,
      header?: SlideOverHeaderProps
    ) {
      const item = {
        content: content,
        header: null
      } as SlideOver
      if (header) item.header = header
      this.openSlideOver(item)
    },

    replaceCurrentSlide(
      content?: SlideOverContentProps,
      header?: SlideOverHeaderProps
    ) {
      const totalSlides = this.items.length

      if ((!content && !header) || totalSlides === 0) return

      if (content) {
        this.items[totalSlides - 1].content = content
      }

      if (header) {
        this.items[totalSlides - 1].header = header
      }
    },

    openSlideOver(item: SlideOver) {
      this.items.push(item)
    },

    closeSlideOver() {
      this.items.pop()
    },

    closeAllSlides() {
      this.items = [] as SlideOver[]
    }
  }
})
